module.exports = __webpack_public_path__ + "img/house-6.ee021f8a.jpeg";